import { Link, styled } from '@mui/material'

export const StyledLink = styled(Link)(() => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
}))
